/**
 * Finance Center - English (US)
 * 财务中心 - 美式英语
 */
export default {
  title: 'Finance Center',
  accountBill: 'Account Bill',
  equityManagement: 'Equity Management',
  goldManagement: 'Gold Management',
  cashAccountManage: 'Cash Account',
  deliveryVoucherManage: 'Delivery Voucher',
  accountAssetsBoard: 'Account Assets Board',
  accountChange: 'Account Change Notice',
  accountBillTitle: 'Account Statement',
  createAccountTogether: 'HQ Co-build Account',
  refundRecord: 'Refund Record',
  // 账户结算单
  settlementOrderNo: 'Settlement No.',
  placeholderSettlementNo: 'Enter settlement no.',
  agentLabel: 'Agent',
  placeholderAgent: 'Select agent',
  accountType: 'Account Type',
  placeholderAccountType: 'Select account type',
  itemType: 'Item',
  placeholderItemType: 'Select item',
  createTimeLabel: 'Create Time',
  expenditureMethod: 'Expenditure/Transfer',
  placeholderSelect: 'Select',
  createByName: 'Created By',
  placeholderCreateByName: 'Enter name',
  settlementStatus: 'Settlement Status',
  placeholderSettlementStatus: 'Select status',
  settlementType: 'Settlement Type',
  lastPayTime: 'Last Pay Time',
  transferAgent: 'Transfer To Agent',
  placeholderTransferAgent: 'Select agent',
  transferAccountType: 'Transfer Account Type',
  placeholderTransferAccountType: 'Select type',
  placeholderContactFromInvoice: 'Auto-filled from invoice, editable',
  activityNameLabel: 'Activity name',
  activityRegionLabel: 'Activity region',
  placeholderActivityRegion: 'Select activity region',
  regionOne: 'Region 1',
  regionTwo: 'Region 2',
  agentId: 'Agent ID',
  agentName: 'Agent Name',
  expenditureMethodName: 'Expenditure/Transfer',
  accountTypeName: 'Account Type',
  itemTypeName: 'Item',
  settlementAmount: 'Amount',
  receivedAmountLabel: 'Received',
  receivedAmountCol: 'Received',
  remarkLabel: 'Remark',
  attachment: 'Attachment',
  transferAgentId: 'Transfer Agent ID',
  transferAgentName: 'Transfer Agent Name',
  transferAccountTypeName: 'Transfer Account Type',
  transferItem: 'Transfer Item',
  lastPayTimeLabel: 'Last Pay Time',
  createTimeCol: 'Create Time',
  dateRangeSep: '~',
  // 账户变动通知
  accountChangeNotice: 'Account Change Notice',
  read: 'Read',
  changeTypeLabel: 'Change Type',
  placeholderChangeType: 'Select type',
  accountRecharge: 'Recharge',
  accountExpenditure: 'Expenditure',
  accountTransfer: 'Transfer',
  statusLabel: 'Status',
  placeholderStatus: 'Select status',
  unread: 'Unread',
  readStatus: 'Read',
  sendTimeLabel: 'Send Time',
  noticeContent: 'Notice Content',
  sendTimeCol: 'Send Time',
  // 退款记录
  refundSummary: '{count} records, total amount ¥{money}',
  orderNo: 'Order No.',
  refundAmount: 'Refund Amount',
  refundAccount: 'Refund Account',
  refundTime: 'Refund Time',
  refundType: 'Refund Type',
  refundBy: 'Refund By',
  placeholderRefundType: 'Select refund type',
  placeholderRefundAccount: 'Select refund account',
  placeholderRefundOrderNo: 'Enter order no.',
  getDataFailed: 'Failed to load',
   // 现金账户 CashAccountManage
  rechargeRecord: 'Recharge Record',
  expenseRecord: 'Expense Record',
  withdrawRecord: 'Withdrawal Record',
  transferCashRecord: 'Transfer to Cash Record',
  withdrawAccount: 'Withdrawal Account',
  withdrawableAmount: 'Withdrawable: ',
  loanType: 'Loan',
  nonLoanType: 'Non-loan',
  nonLoanRebateServiceType: 'Non-loan - Rebate and Service Fee',
  nonLoanReferralCommissionType: 'Non-loan - Referral Commission',
  nonLoanOtherType: 'Non-loan - Other',
  applyWithdraw: 'Apply Withdrawal',
  transferToCashAccount: 'Transfer to Cash',
  loanBalance: 'Loan Balance: ',
  nonLoanBalance: 'Non-loan Balance: ',
  nonLoanRebateServiceBalance: 'Non-loan Rebate and Service Fee Balance: ',
  nonLoanReferralCommissionBalance: 'Non-loan Referral Commission Balance: ',
  nonLoanOtherBalance: 'Non-loan Other Balance: ',
  originalCardRefund: 'Refund to Original Payment Method',
  inventoryCashValue: 'Inventory Cash: ',
  cashYuan: ' yuan',
  serialNo: 'Serial No.',
  rechargeAmount: 'Recharge Amount',
  rechargeMethod: 'Payment Method',
  rechargeTime: 'Recharge Time',
  operatorCol: 'Operator',
  applySuccess: 'Applied successfully.',
  applyFailed: 'Application failed.',
  agentSubjectInvoiceTip: 'Your agent entity is not a company. Please go to Finance Center > Invoice > Invoice Header to submit a company application for approval before withdrawal.',
  transferSuccessTip: 'Submitted. The amount has been transferred to your cash account.',
  withdrawBalanceTip: 'Insufficient loan balance in withdrawal account.',
  transferNoInvoiceTip: 'Transfer from loan account to cash account; no invoice required. Amount transferred.',
  // 提现记录 / 转现记录
  loanWithdrawAmount: 'Loan withdrawal: ',
  nonLoanWithdrawAmount: 'Non-loan withdrawal: ',
  loanTransferTotal: 'Loan transfer total: ',
  nonLoanTransferTotal: 'Non-loan transfer total: ',
  withdrawOrderNo: 'Withdrawal No.',
  withdrawAmount: 'Withdrawal Amount',
  withdrawTime: 'Withdrawal Time',
  rechargeType: 'Recharge Type',
  payee: 'Payee',
  depositBank: 'Bank',
  accountNumber: 'Account No.',
  paymentTime: 'Payment Time',
  payer: 'Payer',
  transferAmount: 'Transfer Amount',
  transferTime: 'Transfer Time',
  applyStatus: 'Status',
  // 提货券 DeliveryVoucherManage
  deliveryVoucher: 'Delivery Voucher',
  accountBalance: 'Balance: ',
  myIssued: 'Issued: ',
  myReceived: 'Received: ',
  myConsumed: 'Consumed: ',
  myVerified: 'Verified: ',
  deliveryVoucherTabMyIssued: 'Issued',
  deliveryVoucherTabMyReceived: 'Received',
  deliveryVoucherTabMyConsumed: 'Consumed',
  deliveryVoucherTabMyVerified: 'Verified',
  // 金账户 GoldManagement
  serviceProviderRights: 'Service Provider Rights',
  goldExpenseRecord: 'Gold Expense Record',
  goldRechargeRecord: 'Gold Recharge Record',
  goldAccount: 'Gold Account',
  totalWithdrawAmount: 'Total Withdrawal: ',
  paidWithdrawAmount: 'Paid Withdrawal: ',
  totalWithdrawAmountCol: 'Total Withdrawal',
  paidWithdrawAmountCol: 'Paid Withdrawal',
  paidOrderTotalAmount: 'Paid Order Total: ',
  retainAmountLabel: 'Retain Amount: ',
  // CashDataModal 支付弹窗
  bankAccountLabel: 'Bank Account: ',
  openingBankLabel: 'Opening Bank: ',
  transferAmountLabel: 'Transfer Amount: ',
  payTimeLabel: 'Payment Time: ',
  payTimeRequired: 'Payment time is required',
  selectPayTime: 'Select payment time',
  paySerialNo: 'Payment Serial No.',
  placeholderPaySerialNo: 'Enter payment serial no.',
  payVoucherLabel: 'Payment Voucher: ',
  payVoucherRequired: 'Voucher is required',
  voucherTip: 'Support jpg/png, recommended 1080x1920, max 5MB',
  voucherExample: 'Example',
  payRemarkLabel: 'Payment Remark: ',
  placeholderPayRemark: 'Enter remark',
  clickUpload: 'Upload',
  paySuccess: 'Payment succeeded',
  payFailed: 'Payment failed',
  // 金账户充值 GoldReCharge
  rechargeNoLabel: 'Recharge No.: ',
  placeholderRechargeNo: 'Enter recharge no.',
  operatorPlaceholder: 'Operator',
  rechargeTimeLabel: 'Recharge Time: ',
  rechargeMethodLabel: 'Recharge Method: ',
  // 金账户消费 GoldExpenseCalendar
  purchaseNo: 'Purchase No.',
  purchaseNoLabel: 'Purchase No.: ',
  productName: 'Product',
  purchaseNum: 'Quantity',
  purchaseAmount: 'Amount',
  goldPayAmount: 'Gold Pay',
  voucherPayAmount: 'Voucher Pay',
  cashPayAmount: 'Cash Pay',
  paymentMethod: 'Payment Method',
  lastPayTimeCol: 'Last Pay Time',
  payTimeLabel: 'Pay Time: ',
  // 申请提现弹窗 CashModel
  applyWithdrawTitle: 'Apply Withdrawal',
  withdrawAutoCalcTip: 'Max withdrawable is calculated by recharge type.',
  rechargeTypeLabel: 'Recharge Type: ',
  placeholderRechargeType: 'Recharge type',
  applyNoLabel: 'Apply No.: ',
  applyNoAutoTip: 'Auto-generated on save, read-only',
  applyWithdrawAmountLabel: 'Withdraw Amount: ',
  placeholderApplyWithdrawAmount: 'Withdraw amount',
  maxWithdrawAmountLabel: 'Max Withdrawable: ',
  payeeNameLabel: 'Payee: ',
  placeholderPayeeName: 'Enter payee name',
  openingBankExample: 'e.g. ICBC Nanjing Fujian Rd Branch',
  openingBankLabel: 'Opening Bank: ',
  placeholderOpeningBank: 'Include province, city, branch',
  accountNoLabel: 'Account No.: ',
  placeholderAccountNo: 'Enter account no.',
  contactPhoneLabel: 'Contact: ',
  placeholderContactPhone: 'From invoice header, editable',
  close: 'Close',
  confirm: 'Confirm',
  noteLabel: 'Note',
  loanInvoiceRemindTitle: 'Loan Invoice Reminder',
  applyNoShort: 'Apply No.',
  invoiceUnit: 'Invoice Unit',
  invoiceIndex: 'Invoice',
  invoiceType: 'Invoice Type',
  invoiceAmount: 'Amount',
  invoiceItem: 'Invoice Item',
  loanInvoiceNote: 'Submit Squirrel invoice red flush first, or submit screenshot of unpaid orders at Finance Center > Agent Account > Withdrawal.',
  gotIt: 'Got it',
  nonLoanInvoiceRemindTitle: 'Non-loan Invoice Reminder',
  nonLoanInvoiceNote: 'After invoicing, submit at Finance Center > Agent Account > Withdrawal.',
  selectRechargeType: 'Please select recharge type',
  inputApplyWithdrawAmount: 'Enter withdraw amount',
  withdrawInsufficientBalance: 'Insufficient balance.',
  inputContactPhone: 'Enter contact phone',
  submitFailed: 'Submit failed',
  // 转现金账户 ChangeCashModel
  transferCashTitle: 'Transfer to Cash',
  applyAmountLabel: 'Amount: ',
  placeholderApplyAmount: 'Enter amount',
  maxApplyAmountLabel: 'Max Amount: ',
  inputTransferAmount: 'Enter transfer amount',
  nonLoanInvoiceNoteTransfer: 'After invoicing, submit at Finance Center > Agent Account > Transfer to Cash.',
  // 提货券列表（发放/收到/消费/核销）
  recordNoLabel: 'Serial No.: ',
  placeholderRecordNo: 'Serial no.',
  purchaseOrderLabel: 'Purchase Order: ',
  placeholderPurchaseOrder: 'Purchase order',
  grantTimeLabel: 'Grant Time: ',
  relatedAgentId: 'Related Agent ID',
  relatedAgentName: 'Related Agent',
  deliveryVoucherAmount: 'Voucher Amount',
  grantAgentId: 'Grant Agent ID',
  grantAgentName: 'Grant Agent',
  purchaseOrder: 'Purchase Order',
  grantTimeCol: 'Grant Time',
  grantBy: 'Grant By',
  belongAgentId: 'Belong Agent ID',
  belongAgentName: 'Belong Agent',
  receiveTime: 'Receive Time',
  consumeVoucherAmount: 'Consume Amount',
  consumeOrderNo: 'Consume Order No.',
  consumeTime: 'Consume Time',
  consumeBy: 'Consume By',
  verifyAgentId: 'Verify Agent ID',
  verifyAgentName: 'Verify Agent',
  verifyAmount: 'Verify Amount',
  verifyOrderNo: 'Verify Order',
  verifyTime: 'Verify Time',
  verifyBy: 'Verify By',
  // 提现/转现搜索与导出
  withdrawRecordExport: 'Withdrawal Record Export',
  withdrawOrderNoLabel: 'Withdrawal No.: ',
  placeholderWithdrawOrderNo: 'Enter withdrawal no.',
  withdrawTimeLabel: 'Withdrawal Time: ',
  paymentTimeLabel: 'Payment Time: ',
  applyStatusLabel: 'Status: ',
  placeholderApplyStatus: 'Select status',
  transferTimeLabel: 'Transfer Time: ',
  transferAccountTypeLabel: 'Transfer Account Type: ',
  statusPendingSubmit: 'Pending Submit',
  statusPendingAudit: 'Pending Audit',
  statusReturned: 'Returned',
  statusPendingPay: 'Pending Pay',
  statusCompleted: 'Completed',
  statusCancelled: 'Cancelled',
  // 支付流水 PaymentFlow
  paymentTotalLabel: 'Total payment ',
  rechargeId: 'Recharge ID',
  rechargeIdLabel: 'Recharge ID',
  placeholderRechargeId: 'Enter recharge ID',
  dataTypeName: 'Payment Type',
  payTimeCol: 'Payment Time',
  payMethodLabel: 'Payment Method: ',
  payTimeLabelSearch: 'Payment Time',
  orderNoLabel: 'Purchase No.',
  placeholderOrderNo: 'Enter purchase no.',
  expenditureMethodLabel: 'Expenditure: ',
  itemTypeLabel: 'Item: ',
  // 转现金账户申请 ApplicationForCash
  applyOrderNo: 'Apply No.',
  applyAmount: 'Amount',
  applyTime: 'Apply Time',
  applicant: 'Applicant',
  auditTime: 'Audit Time',
  auditor: 'Auditor',
  auditRemark: 'Audit Remark',
  contactPhone: 'Contact',
  placeholderContact: 'Enter contact',
  placeholderApplyAmountCash: 'Enter amount',
  invoiceUpload: 'Invoice Upload: ',
  invoiceUploadMaxPdf: 'Max 5 PDF files',
  noInvoiceData: 'No invoice',
  invoiceInfo: 'Invoice Info: ',
  submit: 'Submit',
  save: 'Save',
  cancel: 'Cancel',
  tip: 'Tip',
  confirmSubmitNoInvoice: 'No invoice uploaded. Submit for audit anyway?',
  confirmCancel: 'Confirm cancel?',
  inputContactRequired: 'Enter contact',
  uploadFileTypeLimit: 'Only png, jpg, jpeg, pdf',
  uploadFileSizeLimit: 'Max file size 5MB',
  downloadFailed: 'Download failed',
  operationSuccess: 'Success',
  operationFailedRetry: 'Failed, please retry',
  noInvoiceWarning: 'Please upload invoice before submit.',
  applyOrderNoLabel: 'Apply No.',
  placeholderApplyOrderNo: 'Enter apply no.',
  applyTimeLabel: 'Apply Time',
  paymentTimeLabelApply: 'Payment Time',
  dateRangeTo: ' to ',
  rechargeTypeCol: 'Recharge Type',
  submitInvoice: 'Submit Invoice',
  applyEdit: 'Edit',
  transferCashDetail: 'Transfer to Cash Detail',
  transferCashSubmitInvoice: 'Transfer to Cash - Submit Invoice',
  transferCashEdit: 'Transfer to Cash - Edit',
  // 发票抬头 InvoiceHeader
  invoiceHeaderType: 'Invoice Header Type: ',
  companyType: 'Company',
  personalType: 'Personal',
  companyHeadLabel: 'Company Name: ',
  placeholderCompanyHead: 'Enter company name',
  taxNoLabel: 'Tax No.: ',
  placeholderTaxNo: 'Enter tax no.',
  phoneLabel: 'Phone: ',
  placeholderPhone: 'Enter phone',
  addressLabel: 'Address: ',
  placeholderAddress: 'Enter address',
  placeholderOpeningBankFill: 'Enter opening bank',
  placeholderBankAccountFill: 'Enter bank account',
  placeholderSelectInvoiceType: 'Select invoice type',
  emailLabel: 'Email: ',
  placeholderEmailFill: 'Enter email',
  businessLicenseLabel: 'Business License: ',
  legalIdFrontLabel: 'Legal ID Front: ',
  legalIdBackLabel: 'Legal ID Back: ',
  clickUploadImage: 'Click to upload',
  previewFile: 'Preview',
  deleteFile: 'Delete',
  nameLabel: 'Name: ',
  placeholderName: 'Enter name',
  idCardLabel: 'ID No.: ',
  placeholderIdCard: 'Enter ID no.',
  idCardFrontLabel: 'ID Front: ',
  clickReuploadImage: 'Click to re-upload',
  requireCompanyHead: 'Enter company name',
  requireTaxNo: 'Enter tax no.',
  requirePhone: 'Enter phone',
  requireAddress: 'Enter address',
  requireOpeningBank: 'Enter opening bank',
  requireBankAccount: 'Enter bank account',
  requireInvoiceType: 'Select invoice type',
  requireEmail: 'Enter email',
  requireName: 'Enter name',
  requireIdCard: 'Enter ID no.',
  applyWithdrawAmountLabel: 'Withdraw Amount',
  inputContactPhone: 'Enter contact phone',
  submitSuccess: 'Submitted',
  saveSuccess: 'Saved',
  // 提现申请 RequestWithdrawal
  withdrawApplyDetail: 'Withdrawal Detail',
  withdrawApplySubmitInvoice: 'Withdrawal - Submit Invoice',
  withdrawApplyEdit: 'Withdrawal - Edit',
  cancelSuccess: 'Cancelled',
  cancelFailed: 'Cancel failed',
  invoiceRedFlushTip: 'Upload red-flush invoice first, or upload screenshot of unpaid orders for deduction.',
  // RequestWithdrawal 搜索与表格
  placeholderRechargeTypeSelect: 'Select recharge type',
  rechargeTypeGoods: 'Goods',
  rechargeTypeNonGoods: 'Non-goods',
  placeholderApplyStatusSelect: 'Select apply status',
  statusPendingSubmit: 'Pending submit',
  statusPendingAudit: 'Pending audit',
  statusReturned: 'Returned',
  statusCancelled: 'Cancelled',
  statusPendingPay: 'Pending payment',
  statusCompleted: 'Completed',
  placeholderPaymentTimeRange: 'Select payment time range',
  placeholderCreateTimeRange: 'Select apply time range',
  applyTypeNameCol: 'Apply type',
  applyStatusValueCol: 'Apply status',
  openingBankCol: 'Opening bank',
  bankAccountCol: 'Bank account',
  mobileCol: 'Contact phone',
  submitTimeCol: 'Submit time',
  createByNameCol: 'Applicant',
  auditUserNameCol: 'Auditor',
  remarkCol: 'Audit remark',
  paymentTimeCol: 'Payment time',
  paymentUserNameCol: 'Payer',
  // 服务商权益 ServiceProviderRights
  serviceArea: 'Service Area',
  retainBalance: 'Retain Balance',
  statusShort: 'Status',
  period: 'Period',
  // 参访报销 VisitReimbursement
  reimbursementApply: 'Reimbursement Apply',
  expressNoCol: 'Express No.',
  attachmentCol: 'Attachment',
  viewAction: 'View',
  visitRecordCol: 'Visit Record',
  reimburseNo: 'Reimburse No.',
  placeholderReimburseNo: 'Enter no.',
  applyAmountShort: 'Amount',
  confirmCancelReimburse: 'Confirm cancel this reimbursement?',
  viewAttachment: 'View Attachment',
  visitorName: 'Visitor Name',
  visitPhone: 'Visitor Phone',
  visitCampusId: 'Visit Campus ID',
  visitCampusName: 'Visit Campus',
  storeId: 'Store ID',
  storeAddress: 'Store Address',
  signTime: 'Sign Time',
  reimburseNoLabel: 'Reimburse No.',
  applyStatusShort: 'Status',
  placeholderApplyStatusShort: 'Select status',
  applyTimeShort: 'Apply Time',
  expressNoLabel: 'Express No.',
  auditTimeShort: 'Audit Time',
  dateRangeToShort: ' to ',
  queryFailed: 'Query failed',
  exportRefundListTitle: 'Refund Record Export',
  // 参访报销申请 VisitReimbursementApply
  back: 'Back',
  agentLabelColon: 'Agent:',
  reimburseNoColon: 'Reimburse No.:',
  createByLabel: 'Creator:',
  reimburseTotalAmount: 'Total Amount:',
  expressCompany: 'Express Company:',
  expressPhoneLabel: 'Express Phone:',
  placeholderExpressNo: 'Enter express no.',
  placeholderExpressPhone: 'Enter express phone',
  invoiceMailAddress: 'Invoice Mail Address:',
  recipientInfo: 'Recipient:',
  noticeLabel: 'Notice:',
  reimburseMailTip: 'Please mail paper invoices to the address above and fill in the express no. for processing.',
  reimburseInvoiceUpload: 'Invoice Upload:',
  uploadPdfOrImageTip: 'Upload PDF or images',
  selectVisitRecordBtn: '+ Select Visit Record',
  deleteAction: 'Delete',
  saveBtn: 'Save',
  selectVisitRecordTitle: 'Select Visit Record',
  confirmDeleteTip: 'Confirm delete?',
  promptTitle: 'Prompt',
  validateReimburseAmount: 'Enter reimbursement amount',
  validateExpressCompany: 'Select express company',
  validateExpressNo: 'Enter express no.',
  validateExpressPhone: 'Enter express phone',
  onlyPdfImageTip: 'Only PDF, PNG, JPG, JPEG allowed',
  maxUploadSizeTip: 'Max file size 20M',
  deleteSuccess: 'Deleted.',
  expressPhone11Tip: 'Enter 11-digit express phone',
  pleaseUploadAttachment: 'Upload attachment first',
  pleaseSelectVisitRecord: 'Select visit record first',
  pleaseCompleteReimburseForm: 'Complete the form first',
  modifySuccess: 'Saved',
  // 权益管理 EquityManagement
  equityDescription: 'Equity Description',
  equityDetail: 'Detail',
  equityType: 'Equity Type',
  equityName: 'Equity Name',
  rightCode: 'Equity Code',
  equityForm: 'Equity Form',
  grantPerson: 'Grant By',
  grantTimeLabel: 'Grant Time',
  validityPeriod: 'Validity',
  exclusiveAttr: 'Exclusive Attr',
  placeholderEquityType: 'Select equity type',
  placeholderEquityName: 'Enter equity name',
  placeholderRightCode: 'Enter equity code',
  placeholderEquityForm: 'Select equity form',
  validUntilTime: 'Valid Until',
  equityDescriptionTitle: 'Equity Description',
  equityUsageDesc: 'Equity Note: ',
  equityUsageMethod: 'Usage: ',
  // 账户资产看板 AccountAssetsBoard
  boardDataCutoffTip: 'Data as of: ',
  accountBalanceBoard: 'Account Balance',
  commonAccount: 'Common Account',
  goldAccountShort: 'Gold',
  cashAccountShort: 'Cash',
  fissionBonusAccount: 'Fission Bonus',
  withdrawAccountShort: 'Withdrawal',
  createAccountTogetherShort: 'Create Together',
  convertibleOptionAmount: 'Convertible Option',
  promotionFee: 'Promotion Fee',
  cityFee: 'City Fee',
  deliveryVoucherAccountBoard: 'Delivery Voucher',
  deliveryVoucherBalance: 'Delivery Balance',
  grantedDeliveryVoucher: 'Granted',
  verifiedDeliveryVoucher: 'Verified',
  dualOrderPendingReturn: 'Dual Order Pending',
  equipmentAssets: 'Equipment',
  equipmentType: 'Type',
  cashAmountCol: 'Cash',
  fissionAmount: 'Fission',
  totalCol: 'Total',
  orderAssets: 'Order Assets',
  purchaseOrderSection: 'Purchase Order',
  undeliveredPurchaseTotal: 'Undelivered Total',
  undeliveredPurchaseCash: 'Undelivered Cash',
  undeliveredPurchaseFission: 'Undelivered Fission',
  creditOrderUndeliveredTotal: 'Credit Undelivered Total',
  creditOrderUndeliveredCash: 'Credit Undelivered Cash',
  creditOrderUndeliveredFission: 'Credit Undelivered Fission',
  deliveryOrderSection: 'Delivery Order',
  shippedUnpaidTotal: 'Shipped Unpaid Total',
  shippedUnpaidCash: 'Shipped Unpaid Cash',
  shippedUnpaidFission: 'Shipped Unpaid Fission',
  creditShippedUnpaidTotal: 'Credit Shipped Unpaid Total',
  creditShippedUnpaidCash: 'Credit Shipped Unpaid Cash',
  creditShippedUnpaidFission: 'Credit Shipped Unpaid Fission',
  noPermissionToPage: 'You do not have permission to access this page.',
  // 代理商账户看板 AgentAccount/AccountBoard
  rechargeBtn: 'Recharge',
  inventoryStockValue: 'Inventory value',
  includeFission: 'incl. fission',
  remainingUnordered: 'Remaining unordered',
  withdrawableLabel: '(Withdrawable)',
  loanTypeYuan: 'Loan',
  nonLoanTypeYuan: 'Non-loan',
  inventoryStockValueTipA: 'a. Total of purchase unit price for unactivated full-price learning devices in stock;',
  inventoryStockValueTipB: 'b. Parent-child and sample machines are excluded;',
  transferToCashAccountTitle: 'Transfer to Cash Account',
  rechargeAmountLabel: 'Amount:',
  rechargeNow: 'Recharge Now',
  // 流水汇总 CollectWater
  batchConfirm: 'Batch Confirm',
  batchBindOrder: 'Batch Bind Order',
  flowSummary: '{count} items, total {money}',
  financialConfirm: 'Confirm',
  bindOrder: 'Bind Order',
  paySysNo: 'Pay No.',
  transferAmountCol: 'Transfer Out',
  rebateMonth: 'Rebate Month',
  remark: 'Remark',
  createTime: 'Create Time',
  flowStatus: 'Status',
  confirmUser: 'Confirmed By',
  confirmTimeLabel: 'Confirm Time',
  verifyRemarkCol: 'Confirm Remark',
  placeholderFlowStatus: 'Select status',
  rechargeIdLabel: 'Recharge ID',
  placeholderRechargeId: 'Enter recharge ID',
  statusConfirmed: 'Confirmed',
  flowStatusPendingConfirm: 'Pending',
  statusReturned: 'Returned',
  placeholderConfirmUser: 'Select confirmer',
  collectWaterPurchaseOrderNoLabel: 'Purchase order no.',
  placeholderCollectWaterPurchaseOrderNo: 'Enter purchase order no.',
  // 权益详情 EquityDetails
  equityInfoTitle: 'Equity Info',
  writeOffInfoTitle: 'Write-off Info',
  consNo: 'Write-off No.',
  consTime: 'Write-off Time',
  consType: 'Write-off Type',
  belongCampus: 'Belong Campus',
  equityLevel: 'Equity Level',
  equityAmount: 'Equity Amount',
  applicableProduct: 'Applicable Product',
  equityDiscount: 'Equity Discount',
  marketingActivity: 'Marketing Activity',
  activityPrice: 'Activity Price',
  equityQty: 'Equity Qty',
  // 双重订单余额 DoubleOrderBalance
  newDoubleOrder: 'New Dual Order',
  doubleOrderInactiveTip: 'Agent not activated yet. Continue with dual order?',
  accountActivateTime: 'Activate Time',
  goldAccountBalance: 'Gold Balance',
  cashAccountBalance: 'Cash Balance',
  deliveryVoucherBalanceShort: 'Delivery Balance',
  daysToAutoOrder: 'Days to Auto Order',
  subAgentLabel: 'Sub Agent:',
  placeholderSelectAgent: 'Select agent',
  confirmContinue: 'Continue',
  queryBalanceFail: 'Failed to query balance',
  // 金账户充值 GoldReCharge
  rechargeNoCol: 'Serial no.',
  rechargeAmountCol: 'Recharge amount',
  payMethodCol: 'Pay method',
  payTimeColRecharge: 'Recharge time',
  accountTypeCol: 'Account type',
  createByColRecharge: 'Operator',
  remarkColRecharge: 'Remark',
  operatorLabel: 'Operator:',
  placeholderOperator: 'Operator',
  // WithdrawalsRecord
  withdrawalNoLabel: 'Withdrawal no.:',
  placeholderWithdrawalNo: 'Enter withdrawal no.',
  withdrawalTimeLabel: 'Withdrawal time:',
  serialNoColWithdrawal: 'Serial no.',
  payAmountWithdrawalCol: 'Withdrawal amount',
  withdrawalTimeCol: 'Withdrawal time',
  withdrawalMethodCol: 'Withdrawal method',
  payAmountCol: 'Pay amount',
  purchaseOrderNoCol: 'Purchase order no.',
  purchaseQtyCol: 'Purchase qty',
  purchaseAmountCol: 'Purchase amount',
  purchaseQuantityCol: 'Purchase quantity',
  unitPriceCol: 'Unit price',
  settlementOrderNoCol: 'Settlement no.',
  expenditureMethodCol: 'Expenditure method',
  createByNameCol: 'Operator',
  refundTimeLabel: 'Pay time:',
  valuationCol: 'Valuation',

  // SampleIndexQuery
  sampleIndexHelpDesc: 'Rules and interpretation of sample machine indicators',
  productTypeLabel: 'Product type',
  currentAvailableSampleIndicator: 'Current available sample indicator',
  advanceIndicator: '(Advance)',
  sampleIndexCampusId: 'Agent ID',
  sampleIndexCampusName: 'Agent name',
  sampleIndexModelName: 'Product name',
  sampleIndexLimitCnt: 'Current available sample indicator',
  sampleIndexPurchaseOwnCnt: 'Sample indicator from purchase',
  sampleIndexActivityOwnCnt: 'Sample indicator from activity',
  sampleIndexUseCnt: 'Sample indicator used',
  placeholderSampleModel: 'Enter product model',

  // NewGbChargerIndexQuery
  newGbChargerCampusId: 'Agent ID',
  newGbChargerCampusName: 'Agent name',
  newGbChargerProductName: 'Product name',
  newGbChargerOwnCnt: 'Quota From Purchased Learning Machines',
  newGbChargerUseCnt: 'Used Quota',
  newGbChargerAvailableCnt: 'Available Quota',

  // Invoice quantity decimal (table help popover)
  // PaymentDialog / CashRechargeDialog
  payConfirmTip: 'This payment will deduct:',
  fissionBonusAccount: 'Voucher Bonus Account:',
  promoteAccount: 'Promotion account:',
  cashAccount: 'Cash account:',
  goldAccountPayConfirm: 'Gold account:',
  deliveryVoucherAccount: 'Delivery voucher account:',
  payAmountDisplay: 'Pay ¥{money}',
  paySuccessAmount: 'Successfully paid ¥{money}',
  payFailedAmount: 'Payment failed ¥{money}',
  paySuccessTitle: 'Payment succeeded',
  payFailedTitle: 'Payment failed',
  cashRechargeTitle: 'Cash account recharge',
  rechargeAmountLabel: 'Recharge amount:',
  placeholderRechargeAmount: 'Enter recharge amount',
  paymentMethodLabel: 'Payment method:',
  publicTransfer: 'Bank transfer',
  immediateRecharge: 'Recharge now',
  scanAlipay: 'Scan with Alipay',
  scanWechat: 'Scan with WeChat',
  qrCodeInvalid: 'Invalid QR code URL',
  qrCodeGenerating: 'Generating QR code...',
  payAmountYuan: 'Pay ¥{amount}',
  rechargeSuccess: 'Recharge succeeded',
  done: 'Done',
  orderNoLabel: 'Order no.:',
  ladingNoLabel: 'Lading no.:',
  freightLabel: 'Freight:',
  orderCreateTimeLabel: 'Order time:',
  purchaseQtyLabel: 'Purchase qty:',
  purchaseAmountLabel: 'Purchase amount:',
  includeFreight: '(incl. freight: ¥{amount})',
  receivedAmountLabel: 'Received amount:',
  relatedAgentLabel: 'Related agent:',
  accountBalanceLabel: 'Account balance:',
  procureAgentBalance: 'Procure agent balance:',
  maxDeductibleLabel: 'Max deductible:',
  remainingPayAmountLabel: 'Remaining amount:',
  deliveryVoucherAccountLabel: 'Delivery voucher account:',
  relatedAgentAccountBalance: 'Related agent balance',
  accountBalance: 'Account balance',

  invoiceQuantityDecimalQ: 'Q: Why can invoice quantity be a decimal?',
  invoiceQuantityDecimalA: 'A: Withdrawal amounts from order payments are funds transferred from dealers\' order payments to the agent\'s withdrawal account. Squirrel has already issued sales invoices for dealer orders. When this payment is withdrawn, it requires red-void or reverse sales invoices based on the original order\'s product model, unit price, and amount. Different withdrawal amounts applied to different orders generate different invoice amounts. With fixed amount and unit price, the quantity becomes a decimal.',

  // Equipment to Option
  pleaseSelect: 'Please select',
  columnSnCode: 'SN Code',
  columnWarehouse: 'Warehouse',
  columnModel: 'Model',
  columnInboundTime: 'Inbound Time',
  columnLevelAPrice: 'Level-A Purchase Price',
  columnDiscount: 'Discount',
  columnDiscountedAmount: 'Discounted Amount (￥)',
  columnApplyStatus: 'Apply Status',
  modelLabel: 'Model',
  warehouseLabel: 'Warehouse',
  applyStatusLabel: 'Apply Status',
  submitApplyButton: 'Submit Option Application',
  confirmDialogTitle: 'Submit Option Conversion Application',
  confirmDialogDesc: 'Please confirm the application details. After submission, devices will be locked pending HQ review.',
  deviceCount: 'Device Count',
  totalAmount: 'Total Amount',
  applicant: 'Applicant',
  applicantFormat: '{name} ({campusId})',
  warningTip: 'After submission, an option conversion application will be generated. Once approved, the device will be converted to option status and cannot be dispatched from inventory.',
  submitSuccess: 'Submitted successfully',
  submitFailed: 'Submission failed',
  pleaseSelectDevices: 'Please select devices to submit',
  statusUnapplied: 'Unapplied',
  statusAuditing: 'Auditing',
  statusAudited: 'Audited',
  statusCompleted: 'Completed',
  statusRejected: 'Rejected',
  statusCanceled: 'Canceled',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',
  offlineStore: 'Offline Store',
  optionApplyNo: 'Application No.',
  pleaseEnterOptionApplyNo: 'Enter application no.',
  optionApplyTime: 'Application Time',
  optionAuditTime: 'Audit Time',
  applyDeviceNum: 'Device Count',
  totalOptionAmount: 'Total Option Amount',
  rejectReason: 'Reject Reason',
  operation: 'Operation',
  viewDetail: 'Details',
  optionApplyDetailTitle: 'Option Application Details',
  exportDetail: 'Export Details',
  detailQueryFailed: 'Failed to load details',
  cancelDialogTitle: 'Cancel Option Application',
  cancelDialogContent: 'Cancel this option conversion application?',
  accountBalanceToOptionApply: {
    pageTitle: 'Account Balance to Options',
    applyNo: 'Application No.',
    pleaseEnterApplyNo: 'Enter application no.',
    applyStatus: 'Application Status',
    pleaseSelectApplyStatus: 'Select application status',
    applyTime: 'Application Time',
    goldAccount: 'Gold Account',
    cashAccount: 'Cash Account',
    voucherAccount: 'Fission Account',
    withdrawalAccount: 'Withdrawal Account',
    totalAmount: 'Total Amount',
    auditTime: 'Audit Time',
    rejectReason: 'Reject Reason',
    operation: 'Operation',
    view: 'View',
    modify: 'Modify',
    cancel: 'Cancel',
    applyButton: 'Balance to Options',
    createTitle: 'Balance to Options Application',
    modifyTitle: 'Modify Balance to Options Application',
    viewTitle: 'View Balance to Options Application',
    account: 'Account',
    accountBalance: 'Current Available Balance',
    applyAmount: 'Transfer Amount',
    applyTotalAmount: 'Total Amount',
    applyDialogDesc: 'Select the accounts and amounts to transfer. Each account amount must not exceed the current available balance. Submit and wait for HQ review.',
    auditTip: 'After approval, the application amount will be deducted from each account and recharged to the option account automatically. Rejected applications will not deduct funds.',
    close: 'Cancel',
    confirm: 'Confirm',
    statusAuditing: 'Auditing',
    statusCompleted: 'Completed',
    statusCanceled: 'Canceled',
    statusRejected: 'Rejected',
    queryFailed: 'Query failed',
    balanceQueryFailed: 'Balance query failed',
    totalAmountRequired: 'Total amount must be greater than 0',
    amountOverAvailable: 'Transfer amount must not exceed the current available balance',
    submitSuccess: 'Submitted successfully',
    submitFailed: 'Submit failed',
    cancelSuccess: 'Canceled successfully',
    cancelFailed: 'Cancel failed',
    cancelDialogContent: 'Confirm canceling this balance to options application?'
  },
}
